<template>
  <div id="app">
    <ul class="choices">
      <li v-for="(fixedChoice, key) in choiceRulesFixed">
        <div class="select-option not-swappable">
          <select class="hidden" :name="boxOptionIndex(key, true)">
            <option :value="fixedChoice.term_id" selected>
              {{ fixedChoice.name }}
            </option>
          </select>
          <div class="img-wrapper">
            <img :src="fixedChoice.image" :alt="fixedChoice.name" />
          </div>
          <div class="text-wrapper">
            <h5>{{ fixedChoice.name }}</h5>
            <span class="option">Vast artikel</span>
          </div>
        </div>
      </li>
      <li v-for="freeChoiceIndex in choiceRulesFree.length" :key="freeChoiceIndex">
        <div v-if="Object.keys(freeSelections[freeChoiceIndex - 1]).length === 0" class="select-option"
             @click="openModal(freeChoiceIndex - 1)">
          <div class="img-wrapper">
            <span class="empty-image"></span>
          </div>
          <div class="text-wrapper">
            <h5>Leeg</h5>
            <span class="option">Selecteer artikel</span>
          </div>
        </div>

        <div v-else class="select-option" @click="openModal(freeChoiceIndex - 1)">
          <select class="hidden" :name="boxOptionIndex(freeChoiceIndex)">
            <option v-for="choice in allChoices" :value="choice.term_id" :selected="freeSelections[freeChoiceIndex - 1].term_id === choice.term_id">
              {{ choice.name }}
            </option>
          </select>
          <div class="img-wrapper">
            <img :src="freeSelections[freeChoiceIndex - 1].image" :alt="freeSelections[freeChoiceIndex - 1].name" />
          </div>
          <div class="text-wrapper">
            <h5>{{ freeSelections[freeChoiceIndex - 1].name }}</h5>
            <span class="option">Wissel artikel</span>
          </div>
        </div>
      </li>
      <li v-if="freeProduct">
        <div class="select-option not-swappable">
          <select class="hidden" :name="boxOptionIndex(choiceRulesFixed.length + freeSelections.length, true)">
            <option :value="freeProduct.term_id" selected>
              {{ freeProduct.name }}
            </option>
          </select>
          <div class="img-wrapper">
            <img :src="freeProduct.image" :alt="freeProduct.name" />
          </div>
          <div class="text-wrapper">
            <h5>{{ freeProduct.name }}</h5>
            <span class="option" style="background: #008040;">Heel jaar gratis</span>
          </div>
        </div>
      </li>
    </ul>

    <div id="swapModal" class="modal hidden">
      <button class="close-modal" @click="closeModal()">✕</button>
      <ul class="choices">
        <li v-for="choice in allChoices">
          <div class="select-option" @click="addToBox(choice)">
            <div class="img-wrapper">
              <img :src="choice.image" :alt="choice.name" />
            </div>
            <div class="text-wrapper">
              <h5>{{ choice.name }}</h5>
              <span class="option">Selecteer artikel</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div id="modalBackdrop" @click="closeModal()" class="modal-backdrop hidden"></div>
  </div>
</template>

<script>
export default {
  props: [
    'allChoices',
    'choiceRules',
  ],
  data() {
    return {
      count: 1,
      currentSelect: '',
      freeSelections: this.choiceRules.free,
    }
  },
  setup(props) {
    const choiceRulesFixed = props.choiceRules.fixed;
    const freeProduct = choiceRulesFixed[0];
    choiceRulesFixed.shift();

    return {
      allChoices: props.allChoices,
      choiceRulesFixed: props.choiceRules.fixed,
      choiceRulesFree: props.choiceRules.free,
      freeProduct,
    }
  },
  methods: {
    boxOptionIndex(selectOption, fixed = false) {
      const number = fixed ? selectOption + 1 : Number(selectOption) + Number(this.choiceRules.fixed.length);
      return 'box-option-' + number;
    },
    openModal(selectIndex) {
      this.currentSelect = selectIndex;
      document.getElementById('swapModal').classList.remove('hidden');
      document.getElementById('modalBackdrop').classList.remove('hidden');
    },
    closeModal() {
      document.getElementById('swapModal').classList.add('hidden');
      document.getElementById('modalBackdrop').classList.add('hidden');
    },
    addToBox(choice) {
      this.freeSelections.splice(this.currentSelect, 1, choice);
      this.closeModal();
    }
  },
}
</script>

<style>
#app {
  margin-bottom: 20px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  text-align: center;
}

ul.choices {
  padding: 0;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
  list-style-type: none;
}

ul.choices li {
  margin: 0;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(calc(100% / 3) - 10px);
  border: 1px solid #707070;
  border-radius: 6px;
}

.select-option {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.not-swappable .option {
  opacity: 0.7;
}

.select-option:not(.not-swappable) {
  cursor: pointer;
}

.img-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  overflow: hidden;
}

.img-wrapper img,
.empty-image {
  position: absolute;
  width: calc(100% - 20px);
  height: calc(100% - 20px) !important;
  top: 10px;
  left: 10px;
  border-radius: 6px;
  object-fit: cover;
  object-position: center;
}

.empty-image {
  border: 1px dashed #000000;
}

.text-wrapper {
  margin-top: auto;
}

h5 {
  margin: 15px 0 10px;
  padding: 0 5px;
  width: 100%;
  display: block;
}

.option {
  margin: 0;
  padding: 10px 5px;
  width: 100%;
  display: block;
  background-color: #cc2b3e;
  color: #FFFFFF;
  font-size: 18px;
}

.modal {
  position: fixed;
  top: 10%;
  right: 10%;
  bottom: 10%;
  left: 10%;
  z-index: 2020;
  padding: 30px;
  background-color: #FFFFFF;
  overflow-y: scroll;
}

.close-modal {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  color: #000000;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2019;
  opacity: 0.8;
  background-color: #000000;
}

.hidden {
  display: none;
}

@media (max-width: 782px) {
  ul.choices li {
    flex-basis: calc(50% - 10px);
  }

  .modal {
    top: 5%;
    right: 5%;
    bottom: 5%;
    left: 5%;
    padding: 20px;
  }

  .option {
    font-size: 16px;
  }
}

@media (max-width: 375px) {
  ul.choices li {
    flex-basis: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue